export default __webpack_public_path__ + "static/media/upload-add.aa70eca3.svg";